import curry from "../lib/core/functional/curry";
import { sendJsonRequest } from "./utils";

const composeBody = (entity, entityId, runnerId, userId, status) => {
    const payload = {
        status,
    };

    if (entity === "sections") {
        payload.section_id = entityId;
    } else {
        payload.id = userId;
        payload.site_id = entity === "sites" ? entityId : runnerId;
        payload.tag_id = entity === "tags" ? entityId : undefined;
    }
    return payload;
};

const composeUrl = (entity, userId) =>
    entity === "sections"
        ? "/core/feeds/site/follow_sections/"
        : `/core/feeds/site/follow/${userId}`;

export default curry(function follow(entity, entityId, runnerId, userId, doesFollow) {
    const body = composeBody(entity, entityId, runnerId, userId, doesFollow);

    return sendJsonRequest(composeUrl(entity, userId), "PUT", body);
});
